import { render } from "./ProductsListSimple.vue?vue&type=template&id=5fa81494"
import script from "./ProductsListSimple.vue?vue&type=script&lang=js"
export * from "./ProductsListSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__